/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { ElementBox, OverlayElementBox } from '@tencent/chart/lib/chart-ui/interface';
import { IChartManualLayout, IChartTitle } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';

/**
 * 获取整个图表box
 * @param style
 * @returns
 */
export function getChartBox(style): ElementBox {
    const { height, width } = style;
    return {
        height: Math.floor(height),
        width: Math.floor(width),
        left: 0,
        top: 0,
    };
}

/**
 * 获取图表title box，left,top以图表box为基准
 * @param titleProps
 * @param titleRect
 * @returns
 */
export function getChartTitleBox(titleProps: IChartTitle | undefined | null, titleRect): OverlayElementBox {
    if (titleProps) {
        return {
            height: titleRect.height,
            width: titleRect.width,
            top: titleRect.top,
            left: titleRect.left,
            overlay: !!titleProps.overlay,
        };
    }
    return {
        height: 0,
        width: 0,
        top: 0,
        left: 0,
        overlay: true,
    };
}

/**
 * 获取图表plotArea自定义 box，left,top以图表box为基准
 * 没有自定义布局返回undefined
 * @param chartBox
 * @param layout
 * @returns
 */
export function getPlotAreaLayoutBox(chartBox: ElementBox, layout?: IChartManualLayout): ElementBox | undefined {
    if (layout && Object.keys(layout).length > 0) {
        return {
            width: chartBox.width * layout.width!,
            height: chartBox.height * layout.height!,
            left: chartBox.width * layout.left!,
            top: chartBox.height * layout.top!,
        };
    }

    return undefined;
}
